"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoize;

function memoize(fn) {
  var lastArgs = null;
  var lastResult = null;
  return function () {
    if (!lastArgs || lastArgs.length !== arguments.length || [].some.call(arguments, function (arg, index) {
      return arg !== lastArgs[index];
    })) {
      lastArgs = [].slice.call(arguments);
      lastResult = fn.apply(null, arguments);
    }

    return lastResult;
  };
}